// extracted by mini-css-extract-plugin
export default {"banner":"xZIgL","inversed":"TqNi1","textAlignTop":"A3cml","contentWrapper":"EFtv9","image":"RPXuD","title":"mzeGW","subtitle":"KYyoh","link":"SG1xs"};